module.exports = __webpack_public_path__ + "static/media/hair (29).ad7cbb71.jpg";